export default __webpack_public_path__ + "static/media/CIA-Fast-Track-Geyser-Claim-Form.7801ba9e.pdf";